import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_measures_are_place_prevent_standing_water_due'

export const dataPointDefinition = {
  retracedId: 'no_measures_are_place_prevent_standing_water_due',
  name: 'No measures are in place to prevent standing water due to inadequate drainage',
  description: 'If facility circumstances would never result in danger from standing water, answer Not Applicable.',
  meta: {
    slcpMeta: {
      key: 'hs-bui-18x',
      number: 'HS-BUI-4-2',
      dataType: 'array',
      masterType: 'Question',
      multiSelectKey: 'hs-bui-16',
      optionList: 'xna',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2]',
      machineShowHide: '[2]',
      completionCondition: 'any ms',
    },
    multiSelectKey: 'hs-bui-16',
  },
  fieldTypeId: 'MULTI_SELECT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'xna',
      name: 'xna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'string',
          enum: ['xna'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-bui-18x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29490,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
